import { __read, __values } from "tslib";
export var DetachedWindowRefMaps = new Map();
export var openExternalWindow = function (_a) {
    var e_1, _b;
    var _c = _a.url, url = _c === void 0 ? '' : _c, name = _a.name, specs = _a.specs;
    var _d, _e, _f;
    var newWindow = null;
    try {
        for (var DetachedWindowRefMaps_1 = __values(DetachedWindowRefMaps), DetachedWindowRefMaps_1_1 = DetachedWindowRefMaps_1.next(); !DetachedWindowRefMaps_1_1.done; DetachedWindowRefMaps_1_1 = DetachedWindowRefMaps_1.next()) {
            var _g = __read(DetachedWindowRefMaps_1_1.value, 1), key = _g[0];
            var result = (_e = (_d = key.current) === null || _d === void 0 ? void 0 : _d.window) === null || _e === void 0 ? void 0 : _e.open(url, name, specs);
            if (result) {
                newWindow = result;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (DetachedWindowRefMaps_1_1 && !DetachedWindowRefMaps_1_1.done && (_b = DetachedWindowRefMaps_1.return)) _b.call(DetachedWindowRefMaps_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // * if that hostWindow open fail, try current window open again
    if (!newWindow) {
        // eslint-disable-next-line security/detect-non-literal-fs-filename
        newWindow = window.open(url, name, specs);
        if (!newWindow) {
            return null;
        }
    }
    var body = (_f = newWindow.document) === null || _f === void 0 ? void 0 : _f.body;
    if (!body)
        return null;
    return newWindow;
};
